if ($('.type-category').length) {
    function categoryTopDescription() {
        if ($('.category-top .subcategories').length) {
            $('.category-top').after($('.subcategories'));
            $('.subcategories a .image img').each(function () {
                $(this).attr('data-src', $(this).attr('data-src').replace('/thumb/', '/orig/'))
            })
            var imageLink = $('meta[property="og:image"]').first().attr('content');
            if (imageLink) {
                $('.category-top .category-title').css('grid-column', '2');
                $('.category-top').append('<div class="imageAbsolute"><img src="' + imageLink + '" alt="' + $('h1.category-title').text().trim() + '"></div>')
            }
        }
    }
    function bannerToCategory() {
        if ($('.benefitBanner').length) {
            var bannerLink = $('.benefitBanner .benefitBanner__link').attr('href');
            var bannerTitle = $('.benefitBanner .benefitBanner__title').text();
            var bannerText = $('.benefitBanner .benefitBanner__data').html();
            var bannerTextLink = $('.benefitBanner .benefitBanner__picture img').attr('alt');
            var bannerImage = $('.benefitBanner .benefitBanner__picture img').attr('data-src');
            var newBanner = `
                <div class="product bannerProduct">
                    <div class="p" style="background:url('${bannerImage}')">
                        <div class="h3">${bannerTitle}</div>
                        <div class="text"><p>${bannerText}</p></div>
                        <div class="link"><a href="${bannerLink}">${bannerTextLink}</div>
                    </div>
                </div>
            `
            if ($('.products>.product').length > 4) {
                if (!$('.products .product.bannerProduct').length) {
                    $('.products>.product').eq(3).after(newBanner)
                }

            }
            else {
                if (!$('.products .product.bannerProduct').length) {
                    $('.products>.product').last().after(newBanner)
                }
            }
        }
    }
    function customCategory() {
        if (!$('.category-header .filters-unveil-button-wrapper').length) {
            $('.filters-unveil-button-wrapper').clone().appendTo('.category-header')
        }
        if (!$('#filters-wrapper #filters .close').length) {
            $('#filters-wrapper #filters').prepend('<span class="close"></span>')
        }

        const $fieldsets = $('.filter-section form fieldset');

        $fieldsets.each(function () {
            const $fs = $(this);
            const $items = $fs.children('div').has('input[type="checkbox"]');
            let $btn = $fs.children('.show-more-less');
            if ($items.length <= VisibleFiltersCount) {
            $items.show();
            if ($btn.length) $btn.remove();
            return;
            }
            if (!$btn.length) {
            $btn = $('<button type="button" class="show-more-less">+ načíst další</button>');
            $btn.insertAfter($items.last());
            }
            const expanded = $btn.data('expanded') === true;
            if (expanded) {
            $items.show();
            $btn.text('- načíst méně');
            } else {
            $items.slice(VisibleFiltersCount).hide();
            $btn.text('+ načíst další');
            }
            $btn.off('click.mh').on('click.mh', function () {
            const isExpanded = $btn.data('expanded') === true;
            if (isExpanded) {
                $items.slice(VisibleFiltersCount).slideUp();
                $btn.text('+ načíst další').data('expanded', false);
            } else {
                $items.slice(VisibleFiltersCount).slideDown();
                $btn.text('- načíst méně').data('expanded', true);
            }
            });
        });
        
    }

    function customSorting(){
        if(!$('#category-header .customSorting').length){
            $('#category-header').append('<span class="customSorting">Řadit dle</span>');
        }
    }


    document.addEventListener('ShoptetDOMPageContentLoaded', function () {
        bannerToCategory();
        customCategory();
        categoryTopDescription();
        customSorting();
    });
    document.addEventListener('ShoptetPageSortingChanged', function () {
        bannerToCategory();
        customCategory();
        categoryTopDescription();
        customSorting();
    });
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
        bannerToCategory();
        customCategory();
        categoryTopDescription();
    });
    $(document).ready(function () {
        bannerToCategory();
        customCategory();
        categoryTopDescription();
        customSorting();
    })

    $('html').on('click', '.customSorting', function(){
        $(this).toggleClass('openIt');
        $(this).closest('#category-header').find('.listSorting').toggleClass('openForm')
    })
    $('html').on('click', '#filters span.close', function () {
        $('.filters-unveil-button-wrapper a').trigger('click');
        $('#filters').removeClass('visible');
        $('body').removeClass('filters-visible');
        $('.filters-unveil-button-wrapper a').text('Otevřít filtr').attr('data-text', 'Zavřít filtr ');


    })
    $('html').on('click', '#clear-filters a', function () {
        $('body').removeClass('filters-visible');
    })





}